module.exports = __webpack_public_path__ + "static/img/wait.8bfb308c.png";